import { ReactNode } from 'react';

export enum SHIPPING_MODEL_CONST {
  TEST_ID = 'shipping-model',
}

export type ShippingModelConfig = {
  description?: string;
  icon: ReactNode;
  title?: string;
};

export type ShippingModelProps = Omit<ShippingModelConfig, 'icon'>;
